import { useAuth } from '@/contexts/AuthContext';
import { hasSalaryPermission } from '../Models/collaboratorSalary.types';

/**
 * Hook to check salary-related permissions
 */
export const useSalaryPermissions = () => {
  const { user } = useAuth();
  const userRoles = user?.roles || [];

  // Check specific permissions
  const canViewSalary = hasSalaryPermission(userRoles, 'canViewSalary');
  const canEditSalary = hasSalaryPermission(userRoles, 'canEditSalary');
  const canDeleteHistory = hasSalaryPermission(userRoles, 'canDeleteSalary');

  // Helper to check if user has any salary permission
  const hasAnyPermission = canViewSalary || canEditSalary || canDeleteHistory;

  // Helper to check for specific salary role
  const hasSalaryRole = (role: string): boolean => {
    return userRoles.includes(role);
  };

  // UI state helpers
  const shouldShowSalaryFields = true; // Always show fields, but disabled if no permission
  const shouldEnableSalaryEditing = canEditSalary;
  const shouldShowAsDisabled = !canViewSalary; // Show as disabled/grayed out if no view permission

  return {
    // Permission flags
    canViewSalary,
    canEditSalary,
    canDeleteHistory,
    hasAnyPermission,

    // Role checks
    hasSalaryRole,
    userRoles,

    // UI helpers
    shouldShowSalaryFields,
    shouldEnableSalaryEditing,
    shouldShowAsDisabled,

    // User info
    userId: user?.uid,
    userEmail: user?.email,
  };
};